import { observer } from "mobx-react"
import { TournamentMember } from "../../../../domain/entities/TournamentMember"
import DataTable from "../../../components/DataTable/DataTable"
import { useContainerInjection } from "../../../hooks/useContainerInjection"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import { TournamentMembersViewModel } from "../TournamentMembersViewModel"
import TABLE_COLUMNS from "../const/TOURNAMENT_MEMBERS_TABLE_COLUMNS"

interface TournamentMembersTableProps {
	data: Partial<TournamentMember>[]
	loading?: boolean
	isFetching?: boolean
	onChangePage?: (page: number, pageSize: number, lastPageFetched: number) => void
}

const TournamentMembersTable = ({ data, loading, isFetching, onChangePage }: TournamentMembersTableProps) => {
	const viewModel = useContainerInjection<TournamentMembersViewModel>("TournamentMembersViewModel")

	return (
		<div className="table-responsive">
			<DataTable
				onChangePage={(page, pageSize, lastPageFetched) => {
					viewModel.setTableConfig({ pageSize })
					onChangePage && onChangePage(page, pageSize, lastPageFetched)
				}}
				renderCustomLoadingComponent={() => <DataTableRowsSkeleton size="lg" />}
				loading={loading}
				tableConfig={{
					sort: viewModel.tableConfig.sort,
					pageSize: viewModel.tableConfig.pageSize
				}}
				onChange={data => {
					data.sorter &&
						viewModel.setTableConfig({ sort: { order: data.sorter.order, field: data.sorter.field } })
				}}
				isFetching={isFetching}
				columns={TABLE_COLUMNS()}
				dataSource={data.map(member => ({
					key: member.id,
					id: member.id,
					email: member.email,
					name: member.name,
					surname: member.surname,
					team: member.team
				}))}
			/>
		</div>
	)
}

export default observer(TournamentMembersTable)
